import { Component, AfterViewInit, AfterContentInit, Input, OnInit, ContentChild, ViewChild,ViewContainerRef, TemplateRef, HostListener } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';

@Component({
	selector: 'zx-content-block',
	templateUrl: './content-block.component.html',
	styleUrls: ['./content-block.component.css']
})
export class ContentBlockComponent implements AfterViewInit,OnInit {
	@Input() siderWidth:Number=200;
	@Input("hidden-title") hiddenTitle:boolean;
	
	@ContentChild('title', {static:false}) tpl_title: TemplateRef<void>;
	@ContentChild('titleExtra', {static:false}) tpl_titleExtra: TemplateRef<void>;
	@ContentChild('sider', {static:false}) tpl_sider: TemplateRef<void>;
	@ContentChild('content', {static:false}) tpl_content: TemplateRef<void>;
	@ContentChild('operations', {static:false}) tpl_operations: TemplateRef<void>;
	@ContentChild('extra', {static:false}) tpl_extra: TemplateRef<void>;
	@ContentChild('alerting', {static:false}) tpl_alerting: TemplateRef<void>;
	
	@ViewChild('title', { read: ViewContainerRef, static:false }) titleRef: ViewContainerRef;
	@ViewChild('rowOperationsAndExtra', { read: ViewContainerRef, static:false }) rowOperationsAndExtra: ViewContainerRef;
	@ViewChild('colOperations', { read: ViewContainerRef, static:false }) colOperations: ViewContainerRef;
	@ViewChild('colExtra', { read: ViewContainerRef, static:false }) colExtra: ViewContainerRef;

	ngOnInit(){}

	ngAfterViewInit(){
		try{ // 这里解决title命名冲突的问题
			const c:any = this.titleRef.parentInjector;
			if(c!=null&&c.elDef.element.name == 'nz-card'){
				this.tpl_title = null;
			}
		}catch{}
		this.checkExtraAutoWrap(null);
	}

	@HostListener("window:resize", ['$event']) checkExtraAutoWrap(event){
		try{
			const extraAutoWrap = this.colExtra.element.nativeElement.clientWidth+this.colOperations.element.nativeElement.clientWidth+20 
									> this.rowOperationsAndExtra.element.nativeElement.clientWidth;
			this.colExtra.element.nativeElement.style.float = extraAutoWrap?'left':'right';
		}catch(e){}

	}

	_title;
	@Input("title") set title(title: string|TemplateRef<void>){ this._title = title; }
	get title(){ return this.hiddenTitle?null:this._title||this.tpl_title; }

	_titleExtra;
	@Input("titleExtra") set titleExtra(extra: TemplateRef<void>){this._titleExtra=extra;}
	get titleExtra(): TemplateRef<void>{return this._titleExtra||this.tpl_titleExtra;}
	
	_sider;
	@Input("sider") set sider(sider: TemplateRef<void>){this._sider=sider;}
	get sider(): TemplateRef<void>{return this._sider||this.tpl_sider;}
	
	_content;
	@Input("content") set content(content: TemplateRef<void>){this._content=content;}
	get content(): TemplateRef<void>{return this._content||this.tpl_content;}
	
	_operations;
	@Input("operations") set operations(operations: TemplateRef<void>){this._operations=operations;}
	get operations(): TemplateRef<void>{return this._operations||this.tpl_operations;}
	
	_extra;
	@Input("extra") set extra(extra: TemplateRef<void>){this._extra=extra;}
	get extra(): TemplateRef<void>{return this._extra||this.tpl_extra;}
	
	_alerting;
	@Input("alerting") set alerting(alerting: TemplateRef<void>){this._alerting=alerting;}
	get alerting(): TemplateRef<void>{return this._alerting||this.tpl_alerting;}
}